<template>
  <v-chart ref="chart" :options="options" autoresize />
</template>

<script>
import Vue from 'vue';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/legend';

export default Vue.extend({
  components: {
    'v-chart': ECharts,
  },
  props: {
    tierData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      rawData: [],
      graphData: [],
    };
  },
  computed: {
    options() {
      return {
        legend: {
          icon: 'circle',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: params => {
            const data = this.rawData[params[0].dataIndex];
            const clicks = this.valueFormatter(data.clicks);
            const impressions = this.valueFormatter(data.impressions);
            return `${this.rawData[params[0].dataIndex].name}<br/ >
              <div class="d-flex justify-content-between">
                <div>Impressions:&nbsp;</div>
                <div>${impressions}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div>Clicks:&nbsp;</div>
                <div>${clicks}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div>CTR:&nbsp;</div>
                <div>${data.fixedCtr}%</div>
              </div>
            `;
          },
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: 'category',
          data: this.graphData.map(d => d.name),
        },
        grid: {
          left: '0%',
          right: '4%',
          containLabel: true,
        },
        series: [
          {
            name: 'Impressions',
            type: 'bar',
            color: '#4D92E3',
            data: this.graphData.map(d => d.impressions),
            datasetIndex: 0,
          },
          {
            name: 'Clicks',
            type: 'bar',
            color: '#E39E4D',
            data: this.graphData.map(d => d.clicks),
            datasetIndex: 1,
          },
          {
            name: 'CTR',
            type: 'bar',
            color: '#013069',
            data: this.graphData.map(d => d.ctr),
            datasetIndex: 2,
            barCategoryGap: '40%',
          },
        ],
      };
    },
  },
  watch: {
    tierData: {
      handler(val) {
        if (!val || !val.length) {
          return;
        }

        // Normalize the data, to better show the charts
        let maxImps = 0;
        let maxCtr = 0;
        val.forEach(r => {
          r.name = r.name.charAt(0).toUpperCase() + r.name.slice(1);
          r.fixedCtr = r.ctr.toFixed(2);
          if (r.impressions > maxImps) {
            maxImps = r.impressions;
          }
          if (r.ctr > maxCtr) {
            maxCtr = r.ctr;
          }
        });
        // Reverse here due to the graph way of showing data
        this.rawData = val.slice(0).reverse();
        this.graphData = this.rawData.map(r => {
          return {
            name: r.name,
            // Multiply clicks to make them show in the graph
            clicks: (r.clicks * 100) / maxImps,
            impressions: r.impressions / maxImps,
            ctr: r.ctr / maxCtr,
          };
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    valueFormatter(val) {
      return this.$options.filters.thousandsFormatter(val);
    },
  },
});
</script>

<style scoped></style>
